export const BUSINESS_CONTEXTS = Object.freeze({
  FOR_RENT: 'RENT',
  FOR_SALE: 'SALE',
});

export const BUSINESS_CONTEXT_LABELS = Object.freeze({
  [BUSINESS_CONTEXTS.FOR_RENT]: 'Aluguel',
  [BUSINESS_CONTEXTS.FOR_SALE]: 'Venda',
});

const CONTEXT_ALIASES = Object.freeze({
  rent: BUSINESS_CONTEXTS.FOR_RENT,
  rental: BUSINESS_CONTEXTS.FOR_RENT,
  aluguel: BUSINESS_CONTEXTS.FOR_RENT,
  locacao: BUSINESS_CONTEXTS.FOR_RENT,
  locação: BUSINESS_CONTEXTS.FOR_RENT,
  for_rent: BUSINESS_CONTEXTS.FOR_RENT,
  sale: BUSINESS_CONTEXTS.FOR_SALE,
  sales: BUSINESS_CONTEXTS.FOR_SALE,
  venda: BUSINESS_CONTEXTS.FOR_SALE,
  comprar: BUSINESS_CONTEXTS.FOR_SALE,
  compra: BUSINESS_CONTEXTS.FOR_SALE,
  purchase: BUSINESS_CONTEXTS.FOR_SALE,
  for_sale: BUSINESS_CONTEXTS.FOR_SALE,
});

const normalizeSingleContext = value => {
  if (!value) return null;

  const raw = String(value).trim();
  const upperValue = raw.toUpperCase();
  if (Object.values(BUSINESS_CONTEXTS).includes(upperValue)) {
    return upperValue;
  }

  return CONTEXT_ALIASES[raw.toLowerCase()] || null;
};

export const normalizeBusinessContexts = contexts => {
  const list = Array.isArray(contexts) ? contexts : [contexts];
  const normalized = list.map(normalizeSingleContext).filter(Boolean);

  return [...new Set(normalized)].length
    ? [...new Set(normalized)]
    : [BUSINESS_CONTEXTS.FOR_RENT];
};

export const primaryBusinessContext = contexts =>
  normalizeBusinessContexts(contexts)[0];

export {
  QA_FINALIDADE_BY_REFERENCE_CONTEXT as FINALIDADE_BY_REFERENCE_BUSINESS_CONTEXT,
  QA_PROPERTY_OFFER_CONTEXT_BY_REFERENCE as PROPERTY_OFFER_BUSINESS_CONTEXT_BY_REFERENCE,
  normalizeQaFinalidade as normalizeFinalidadeFromBusinessContext,
  normalizeQaPropertyOfferBusinessContext as normalizePropertyOfferBusinessContext,
} from './quintoAndarParity';
